/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { B50, B75, B300, N20, N40, N400, B100 } from '@atlaskit/theme/colors';
/**
 * Default styling px height for an emoji reaction
 */
var akHeight = 24;

/**
 * Styling Note:
 * Padding and line height are set within the child components
 * of FlashAnimation b/c it otherwise throws off the flash styling
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var containerStyle = css({
  position: 'relative'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiStyle = css({
  transformOrigin: 'center center 0',
  lineHeight: '12px',
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-100, 8px)")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var reactionStyle = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  minWidth: '36px',
  height: "".concat(akHeight, "px"),
  background: 'transparent',
  border: "1px solid ".concat("var(--ds-border, ".concat(N40, ")")),
  boxSizing: 'border-box',
  borderRadius: '20px',
  color: "".concat("var(--ds-text-subtle, ".concat(N400, ")")),
  cursor: 'pointer',
  margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-050, 4px)", " 0 0"),
  padding: 0,
  transition: '200ms ease-in-out',
  '&:hover': {
    background: "".concat("var(--ds-background-neutral-subtle-hovered, ".concat(N20, ")"))
  },
  '&:focus': {
    boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
    // background, box-shadow
    transitionDuration: '0s, 0.2s',
    // disabling browser focus outline
    outline: 'none'
  },
  overflow: 'hidden'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var reactedStyle = css({
  backgroundColor: "var(--ds-background-selected, ".concat(B50, ")"),
  borderColor: "var(--ds-border-selected, ".concat(B300, ")"),
  '&:hover': {
    background: "".concat("var(--ds-background-selected-hovered, ".concat(B75, ")"))
  }
});
export var flashHeight = akHeight - 2; // height without the 1px border

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var flashStyleOld = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: '10px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  height: "".concat(flashHeight, "px")
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var flashStyle = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: "var(--ds-border-radius-050, 2px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  height: "".concat(flashHeight, "px")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var emojiNoReactionStyle = css({
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-025, 2px)", " ", "var(--ds-space-050, 4px)", " 10px")
});